/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Lead/view.blocks to change it.
import * as fromData from 'Simple/Data'
import LeadPreview from 'DesignSystem/LeadPreview/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Lead({
  children,
  viewPath = "/DesignSystem/PersonMatches/Content/PersonMatch/Details/Content/Lead",
  handleClose
  
}) {
let personMatchIdValueData = fromData.useDataValue({ viewPath,
context: 'person_match',
path: 'id',
})
  return (<React.Fragment
>
<LeadPreview
  viewPath={`${viewPath}/LeadPreview`}
 data="person_match.id"
 leadId={personMatchIdValueData}
 showNextActions={false}
 handleClose={handleClose}
 hideActions={true}
/>
{children}
</React.Fragment>)
}